import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-drawer", {
    staticClass: "ai-chat-drawer",
    attrs: {
      visible: _vm.drawerVisible,
      direction: "rtl",
      size: "480px",
      "with-header": false,
      "modal-append-to-body": true,
      "append-to-body": true
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.drawerVisible = $event;
      },
      close: _vm.handleClose
    }
  }, [_c("div", {
    staticClass: "ai-chat-container"
  }, [_c("div", {
    staticClass: "chat-header"
  }, [_c("div", {
    staticClass: "header-left"
  }, [_c("i", {
    staticClass: "el-icon-data-analysis"
  }), _c("span", [_vm._v("AI 数据助手")])]), _c("div", {
    staticClass: "header-right"
  }, [_c("el-popover", {
    attrs: {
      placement: "bottom-end",
      width: "320",
      trigger: "click"
    },
    model: {
      value: _vm.showQuestionPopover,
      callback: function callback($$v) {
        _vm.showQuestionPopover = $$v;
      },
      expression: "showQuestionPopover"
    }
  }, [_c("div", {
    staticClass: "question-popover"
  }, [_c("div", {
    staticClass: "question-panel-title"
  }, [_c("span", [_vm._v("常见问题")]), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      icon: "el-icon-refresh"
    },
    on: {
      click: _vm.loadSuggestedQuestions
    }
  }, [_vm._v("刷新")])], 1), _vm.suggestionLoading ? _c("div", {
    staticClass: "suggestion-loading"
  }, [_c("i", {
    staticClass: "el-icon-loading"
  }), _vm._v(" 正在加载... ")]) : _vm.visibleQuestionGroups.length > 0 ? _c("div", [_c("div", {
    staticClass: "question-tabs"
  }, _vm._l(_vm.visibleQuestionGroups, function (group) {
    return _c("button", {
      key: group.name,
      staticClass: "question-tab",
      class: {
        active: _vm.activeQuestionGroup === group.name
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          _vm.activeQuestionGroup = group.name;
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getShortGroupName(group.name)) + " ")]);
  }), 0), _c("div", {
    staticClass: "question-scroll"
  }, [_vm.activeQuestionGroupData ? _c("div", {
    staticClass: "question-group active"
  }, _vm._l(_vm.activeQuestionGroupData.questions, function (question) {
    return _c("button", {
      key: question,
      staticClass: "question-chip",
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.useSampleQuestion(question);
        }
      }
    }, [_vm._v(" " + _vm._s(question) + " ")]);
  }), 0) : _vm._e()])]) : _c("div", {
    staticClass: "question-empty"
  }, [_vm._v(" 暂无可用常见问题 ")])]), _c("el-button", {
    staticClass: "header-btn",
    attrs: {
      slot: "reference",
      type: "text",
      icon: "el-icon-question"
    },
    slot: "reference"
  })], 1), _c("el-tooltip", {
    attrs: {
      content: "新对话",
      placement: "bottom"
    }
  }, [_c("el-button", {
    staticClass: "header-btn",
    attrs: {
      type: "text",
      icon: "el-icon-plus"
    },
    on: {
      click: _vm.createNewConversation
    }
  })], 1), _c("el-popover", {
    attrs: {
      placement: "bottom-end",
      width: "280",
      trigger: "click"
    },
    model: {
      value: _vm.showConversations,
      callback: function callback($$v) {
        _vm.showConversations = $$v;
      },
      expression: "showConversations"
    }
  }, [_c("div", {
    staticClass: "conversations-list"
  }, [_c("div", {
    staticClass: "conversations-title"
  }, [_vm._v("历史会话")]), _vm._l(_vm.conversations, function (conv) {
    return _c("div", {
      key: conv.id,
      staticClass: "conversation-item",
      class: {
        active: conv.id === _vm.currentConversationId
      },
      on: {
        click: function click($event) {
          return _vm.switchConversation(conv.id);
        }
      }
    }, [_c("span", {
      staticClass: "conv-title"
    }, [_vm._v(_vm._s(conv.title))]), _c("i", {
      staticClass: "el-icon-delete",
      on: {
        click: function click($event) {
          $event.stopPropagation();
          return _vm.deleteConversationHandler(conv.id);
        }
      }
    })]);
  }), _vm.conversations.length === 0 ? _c("div", {
    staticClass: "no-conversations"
  }, [_vm._v(" 暂无历史会话 ")]) : _vm._e()], 2), _c("el-button", {
    staticClass: "header-btn",
    attrs: {
      slot: "reference",
      type: "text",
      icon: "el-icon-time"
    },
    slot: "reference"
  })], 1), _c("el-button", {
    staticClass: "header-btn close-btn",
    attrs: {
      type: "text",
      icon: "el-icon-close"
    },
    on: {
      click: _vm.handleClose
    }
  })], 1)]), _c("div", {
    ref: "messagesContainer",
    staticClass: "messages-container"
  }, [_vm.currentMessages.length === 0 ? _c("div", {
    staticClass: "welcome-message"
  }, [_c("div", {
    staticClass: "welcome-hero"
  }, [_c("div", {
    staticClass: "welcome-icon"
  }, [_c("i", {
    staticClass: "el-icon-data-analysis"
  })]), _c("h3", [_vm._v("聚全智能数据助手")]), _c("p", [_vm._v("直接问业务数据，我会按权限查询并给出结果。")])]), _c("div", {
    staticClass: "question-panel"
  }, [_c("div", {
    staticClass: "question-panel-title"
  }, [_c("span", [_vm._v("常见问题")]), _c("el-button", {
    attrs: {
      type: "text",
      size: "mini",
      icon: "el-icon-refresh"
    },
    on: {
      click: _vm.loadSuggestedQuestions
    }
  }, [_vm._v("刷新")])], 1), _vm.suggestionLoading ? _c("div", {
    staticClass: "suggestion-loading"
  }, [_c("i", {
    staticClass: "el-icon-loading"
  }), _vm._v(" 正在加载常见问题... ")]) : _vm.visibleQuestionGroups.length > 0 ? _c("div", {
    staticClass: "question-groups"
  }, [_c("div", {
    staticClass: "question-tabs"
  }, _vm._l(_vm.visibleQuestionGroups, function (group) {
    return _c("button", {
      key: group.name,
      staticClass: "question-tab",
      class: {
        active: _vm.activeQuestionGroup === group.name
      },
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          _vm.activeQuestionGroup = group.name;
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.getShortGroupName(group.name)) + " ")]);
  }), 0), _c("div", {
    staticClass: "question-scroll"
  }, [_vm.activeQuestionGroupData ? _c("div", {
    staticClass: "question-group active"
  }, _vm._l(_vm.activeQuestionGroupData.questions, function (question) {
    return _c("button", {
      key: question,
      staticClass: "question-chip",
      attrs: {
        type: "button"
      },
      on: {
        click: function click($event) {
          return _vm.useSampleQuestion(question);
        }
      }
    }, [_vm._v(" " + _vm._s(question) + " ")]);
  }), 0) : _vm._e()])]) : _c("div", {
    staticClass: "question-empty"
  }, [_vm._v(" 暂无可用常见问题 ")])])]) : _vm._e(), _vm._l(_vm.currentMessages, function (msg, index) {
    return _c("div", {
      key: index,
      staticClass: "message-item",
      class: msg.role
    }, [_c("div", {
      staticClass: "message-avatar"
    }, [msg.role === "user" ? _c("img", {
      attrs: {
        src: _vm.userAvatar,
        alt: "user"
      }
    }) : _c("img", {
      attrs: {
        src: "/favicon.ico",
        alt: "ai"
      }
    })]), _c("div", {
      staticClass: "message-content"
    }, [msg.thinking ? _c("div", {
      staticClass: "thinking-block"
    }, [_c("div", {
      staticClass: "thinking-header",
      on: {
        click: function click($event) {
          return _vm.toggleThinking(index);
        }
      }
    }, [_c("i", {
      class: msg.thinkingExpanded ? "el-icon-arrow-down" : "el-icon-arrow-right"
    }), _c("span", [_vm._v("思考过程")])]), _c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: msg.thinkingExpanded,
        expression: "msg.thinkingExpanded"
      }],
      staticClass: "thinking-content"
    }, [_vm._v(" " + _vm._s(msg.thinking) + " ")])]) : _vm._e(), _c("div", {
      staticClass: "message-text",
      domProps: {
        innerHTML: _vm._s(_vm.formatMessage(msg.content))
      }
    })])]);
  }), _vm.loading ? _c("div", {
    staticClass: "message-item assistant loading"
  }, [_c("div", {
    staticClass: "message-avatar"
  }, [_c("img", {
    attrs: {
      src: "/favicon.ico",
      alt: "ai"
    }
  })]), _c("div", {
    staticClass: "message-content"
  }, [_vm.streamingThinking ? _c("div", {
    staticClass: "thinking-block streaming"
  }, [_c("div", {
    staticClass: "thinking-header"
  }, [_c("i", {
    staticClass: "el-icon-loading"
  }), _c("span", [_vm._v("思考中...")])]), _c("div", {
    staticClass: "thinking-content"
  }, [_vm._v(" " + _vm._s(_vm.streamingThinking) + " ")])]) : _vm._e(), !_vm.streamingContent ? _c("div", {
    staticClass: "message-text typing-indicator"
  }, [_c("span"), _c("span"), _c("span")]) : _c("div", {
    staticClass: "message-text",
    domProps: {
      innerHTML: _vm._s(_vm.formatMessage(_vm.streamingContent))
    }
  })])]) : _vm._e()], 2), _c("div", {
    staticClass: "input-container"
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      rows: 2,
      placeholder: "例如：本月学生出席率是多少。Enter 发送，Shift+Enter 换行",
      resize: "none"
    },
    nativeOn: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.handleKeydown.apply(null, arguments);
      }
    },
    model: {
      value: _vm.inputMessage,
      callback: function callback($$v) {
        _vm.inputMessage = $$v;
      },
      expression: "inputMessage"
    }
  }), _c("div", {
    staticClass: "input-actions"
  }, [_vm.loading ? _c("el-button", {
    attrs: {
      type: "danger",
      size: "small",
      icon: "el-icon-video-pause"
    },
    on: {
      click: _vm.stopGeneration
    }
  }, [_vm._v(" 停止 ")]) : _c("el-button", {
    attrs: {
      type: "primary",
      size: "small",
      icon: "el-icon-s-promotion",
      disabled: !_vm.inputMessage.trim()
    },
    on: {
      click: _vm.sendMessage
    }
  }, [_vm._v(" 发送 ")])], 1)], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };